<template>
<div class="vliveContentEdit form dialog-form">
    <el-dialog title="添加栏目" :visible.sync="dialogVisible">
        <el-form :model="item" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="模块类型" prop="name" v-if="flag === 'add'">
                <el-radio-group v-model="item.columntype" @change="getSelectList">
                    <el-radio :label="columntype.code" v-for="(columntype, index) in columntypeList" :key="index">{{columntype.name}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="模块名称" prop="columnname">
                <el-input v-model.trim="item.columnname" maxlength="30" show-word-limit clearable></el-input>
            </el-form-item>
            <div v-if="flag === 'add'">
                <el-form-item label="选择相册" class="no-margin" v-if="item.columntype==2" prop="relinnerid">
                    <el-select v-model="item.relinnerid" placeholder="请输入关键词选择" filterable>
                        <el-option v-for="item in options" :key="item.innerid" :label="item.catename" :value="item.innerid"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择合集" class="no-margin" v-if="item.columntype==3" prop="relinnerid">
                    <el-select v-model="item.relinnerid" placeholder="请输入关键词选择" filterable>
                        <el-option v-for="item in options" :key="item.innerid" :label="item.catename" :value="item.innerid"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择直播" class="no-margin" v-if="item.columntype==4" prop="relinnerid">
                    <el-select v-model="item.relinnerid" placeholder="请输入关键词选择" filterable remote
                               reserve-keyword :remote-method="remoteMethod" :loading="loading">
                        <el-option v-for="item in options" :key="item.innerid" :label="item.livesubject" :value="item.innerid"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="自定义链接" prop="linkurl" v-if="item.columntype==99">
                    <el-input v-model.trim="item.linkurl" maxlength="100" show-word-limit clearable></el-input>
                </el-form-item>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
    </span>
    </el-dialog>
</div>
</template>

<script>
import {getVliveContentView, addVliveContent, getVliveContentImgTextList, editVliveContent} from 'api/api'
import {getColList} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import {vliveMsg} from 'api/message'
export default {
    name: 'vliveContentEdit',
    data() {
        const checkLinkurl = (rule, value, callback) => {
            if (value) {
                if (value.startsWith('http://') || value.startsWith('https://')) {
                    callback()
                } else {
                    callback(new Error('请输入以http://或https://开头的链接'))
                }
            }
        }
        return {
            dialogVisible: false,
            loading: false,
            columntypeAllList: [
                {code: 1, name: '图文'},
                {code: 2, name: '视频集合'},
                {code: 3, name: '相册'},
                // {code: 4, name: '图文直播'},
                {code: 5, name: '评论'},
                {code: 99, name: '自定义链接'}
            ],
            columntypeList: [],
            value: [],
            list: [],
            options: [],
            item: {
                assetinnerid: this.$route.query.id ? this.$route.query.id : '',
                innerid: '',
                columntype: 1, // 模块类型(1图文 2视频合集 3相册 4图文直播 5评论)
                columnindex: 1,
                columnname: '',
                relinnerid: '',
                linkurl: ''
            },
            rules: {
                columnname: [
                    {required: true, message: '请输入名称', trigger: 'blur'},
                    {min: 3, max: 32, message: '长度在3到32个字符', trigger: 'blur'}
                ],
                relinnerid: [
                    {required: true, message: '请输入名称', trigger: 'blur'}
                ],
                linkurl: [
                    {required: true, message: '请输入自定义链接', trigger: 'blur'},
                    {validator: checkLinkurl, trigger: 'blur'}
                ]
            },
            page: {
                page: 1,
                pageSize: 8
            },
            param: {
                livesubject: ''
            },
            flag: '' // 标识是新增还是修改
        }
    },
    mounted() {},
    methods: {
        remoteMethod(query) {
            if (query !== '') {
                this.loading = true
                this.param.livesubject = query
                this._getVliveContentImgTextList()
            } else {
                this.options = []
            }
        },
        // 获取视频分组id/图片分组id/图文 // materialtype 1视频 2图片
        getSelectList(checked) {
            switch (checked) {
            case 2: this._getColList(1)
                break
            case 3: this._getColList(2)
                break
            case 4: this._getVliveContentImgTextList()
                break
            }
        },
        openDialog(row, columntype) {
            this.dialogVisible = true
            this.columntypeList = JSON.parse(JSON.stringify(this.columntypeAllList))
            if (row === 'add') {
                this.flag = 'add'
                this.columntypeAllList.forEach((obj1, index) => {
                    columntype.forEach(obj2 => {
                        if (obj1.code === obj2 && obj1.code !== 99) {
                            delete this.columntypeList[index]
                        }
                    })
                })
                this.columntypeList = this.columntypeList.filter(obj => obj)
                this.getSelectList(this.columntypeList[0].code)
                this.item = {
                    assetinnerid: this.$route.query.id ? this.$route.query.id : '',
                    columntype: this.columntypeList[0].code,
                    columnindex: 1,
                    columnname: '',
                    relinnerid: ''
                }
            } else {
                this._getView(row.innerid)
            }
        },
        cancel() {
            this.$confirm(vliveMsg.cancelVliveOneContent.msg, vliveMsg.cancelVliveOneContent.title, {
                confirmButtonText: vliveMsg.cancelVliveOneContent.confirmText,
                cancelButtonText: vliveMsg.cancelVliveOneContent.cancelText
            }).then(() => {
                this._cancel()
            })
        },
        _cancel() {
            this.$refs.ruleForm.resetFields()
            this.dialogVisible = false
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm(vliveMsg.submitVliveOneContent.msg, vliveMsg.submitVliveOneContent.title, {
                        confirmButtonText: vliveMsg.submitVliveOneContent.confirmText,
                        cancelButtonText: vliveMsg.submitVliveOneContent.cancelText
                    }).then(() => {
                        if (this.item.innerid) {
                            this._editVliveContent()
                        } else {
                            this._addVliveContent()
                        }
                    })
                }
            })
        },
        _addVliveContent() {
            this.setLoading(true)
            addVliveContent({
                data: this.item,
                success: data => {
                    this.$message.success(vliveMsg.submitVliveOneContent.successMsg)
                    this.setLoading(false)
                    this._cancel()
                    this.$emit('getVliveContentList')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _editVliveContent() {
            this.setLoading(true)
            editVliveContent({
                data: this.item,
                success: data => {
                    this.$message.success(vliveMsg.submitVliveOneContent.successMsg)
                    this.setLoading(false)
                    this._cancel()
                    this.$emit('getVliveContentList')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取图文直播列表
        _getVliveContentImgTextList() {
            getVliveContentImgTextList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.options = data.data.content
                    this.setLoading(false)
                    this.loading = false
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取视频/图片合集
        _getColList(materialtype) {
            this.setLoading(true)
            getColList({
                data: Object.assign({}, {materialtype: materialtype, hostinfoinnerid: this.user.hostinnerid}, this.page),
                success: data => {
                    this.options = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 获取直播内容
        _getView(innerid) {
            getVliveContentView({
                data: {
                    innerid: innerid
                },
                success: data => {
                    this.item = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveContentEdit {
    .el-dialog__body {
        padding: 20px 0;
    }
    .el-input .el-input__count .el-input__count-inner{
        line-height: 28px;
    }
}
</style>
